import { ExternalLink, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative bg-[#0b2545] text-slate-200" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-12 gap-y-10 gap-x-4 md:gap-10">
          <div className="col-span-12 lg:col-span-5">
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-md bg-white/10 flex items-center justify-center">
                <svg viewBox="0 0 24 24" className="w-6 h-6 text-white" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 2 L4 22 L12 17 L20 22 Z" />
                  <path d="M12 2 L12 17" opacity="0.6" />
                </svg>
              </div>
              <div>
                <div className="text-[15px] font-display font-semibold tracking-tight text-white">Gruppo Vela</div>
                <div className="text-[11px] font-medium uppercase tracking-[0.18em] text-[#a9d6e5]">Home Exchange Copilot AI</div>
              </div>
            </div>
            <p className="mt-6 text-sm text-slate-300/90 leading-relaxed max-w-md">
              Unità tecnica di valutazione immobiliare di Gruppo Vela. Metodo MCM,
              presidio continuo del territorio, perizie difendibili in sede peritale e bancaria.
            </p>

            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              className="mt-7 inline-flex items-center gap-3 group text-white hover:text-[#a9d6e5] transition-colors"
              data-testid="footer-gruppovela-link"
            >
              <span className="text-[10px] uppercase tracking-[0.2em] font-medium text-[#a9d6e5]/80 group-hover:text-[#a9d6e5]">Parent Brand</span>
              <span className="text-base font-medium border-b border-dotted border-white/40 group-hover:border-[#a9d6e5]">Visita Gruppo Vela</span>
              <ExternalLink className="w-3.5 h-3.5" />
            </a>
          </div>

          <div className="col-span-6 lg:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.2em] font-medium text-[#a9d6e5] mb-5">Navigazione</div>
            <ul className="space-y-3 text-sm">
              <li><a href="#mcm" className="text-slate-300 hover:text-white transition-colors">Metodo MCM</a></li>
              <li><a href="#dashboard" className="text-slate-300 hover:text-white transition-colors">Dati Live</a></li>
              <li><a href="#radar" className="text-slate-300 hover:text-white transition-colors">Logica di Certezza</a></li>
              <li><a href="#whitepaper" className="text-slate-300 hover:text-white transition-colors">White Paper</a></li>
              <li><a href="#audit" className="text-slate-300 hover:text-white transition-colors">Audit Tecnico</a></li>
            </ul>
          </div>

          <div className="col-span-6 lg:col-span-4">
            <div className="text-[10px] uppercase tracking-[0.2em] font-medium text-[#a9d6e5] mb-5">Coordinate</div>
            <dl className="space-y-3 text-sm">
              <div className="flex items-center justify-between border-b border-white/10 pb-2.5">
                <dt className="text-slate-400">Aree presidiate</dt>
                <dd className="text-white inline-flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5 text-[#a9d6e5]" />Tutta Italia</dd>
              </div>
              <div className="flex items-center justify-between border-b border-white/10 pb-2.5">
                <dt className="text-slate-400">Standard</dt>
                <dd className="text-white">IVS / EVS · MCM</dd>
              </div>
              <div className="flex items-center justify-between border-b border-white/10 pb-2.5">
                <dt className="text-slate-400">Versione</dt>
                <dd className="text-white">2026.01</dd>
              </div>
              <div className="flex items-center justify-between">
                <dt className="text-slate-400">Anno di riferimento</dt>
                <dd className="text-white">2026</dd>
              </div>
            </dl>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-[12px] text-slate-400">
          <div>© {new Date().getFullYear()} Gruppo Vela · Home Exchange Copilot AI · Valutazione immobiliare MCM.</div>
          <div className="flex gap-6">
            <a href="/privacy" className="hover:text-white transition-colors" data-testid="footer-privacy">Privacy</a>
            <a href="/cookie" className="hover:text-white transition-colors" data-testid="footer-cookie">Cookie</a>
            <a href="/termini" className="hover:text-white transition-colors" data-testid="footer-legal">Termini d'uso</a>
            <a href="/agenzie" className="hover:text-white transition-colors" data-testid="footer-agenzie">Per le Agenzie</a>
            <a href="/admin" className="hover:text-white transition-colors" data-testid="footer-admin">Area riservata</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
